/* Clean Squad — Style CG : panier, offre, page produit */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cg-drawer]');
  var cfg = {
    free: drawer ? parseFloat(drawer.dataset.free || '0') * 100 : 0,
    giftMin: drawer ? parseFloat(drawer.dataset.giftMin || '0') * 100 : 0,
    giftVariant: drawer ? parseInt(drawer.dataset.giftVariant || '0', 10) : 0,
    giftTitle: drawer ? drawer.dataset.giftTitle || '' : ''
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  var busy = false;

  function dt(cents) { return Math.round(cents / 100) + ' DT'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function api(path, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }
  function getCart() { return api('cart.js'); }

  function isGift(line) { return line.properties && line.properties._gift; }
  function paidTotal(cart) {
    var t = 0;
    cart.items.forEach(function (l) { if (!isGift(l)) { t += l.final_line_price; } });
    return t;
  }

  function syncGift(cart) {
    if (!cfg.giftVariant || !cfg.giftMin) { return Promise.resolve(cart); }
    var giftLine = null;
    cart.items.forEach(function (l) { if (isGift(l)) { giftLine = l; } });
    var paid = paidTotal(cart);
    if (paid >= cfg.giftMin && !giftLine) {
      return api('cart/add.js', { items: [{ id: cfg.giftVariant, quantity: 1, properties: { _gift: '1' } }] })
        .then(getCart).catch(function () { return cart; });
    }
    if (giftLine && (paid < cfg.giftMin || giftLine.quantity > 1)) {
      return api('cart/change.js', { id: giftLine.key, quantity: paid < cfg.giftMin ? 0 : 1 })
        .catch(function () { return cart; });
    }
    return Promise.resolve(cart);
  }

  function offerState(amount) {
    var target = cfg.giftMin && cfg.giftVariant ? cfg.giftMin : cfg.free;
    var pct = target ? Math.min(100, Math.round(amount / target * 100)) : 100;
    var txt = '';
    var gift = cfg.giftTitle ? cfg.giftTitle : 'ton cadeau';
    if (cfg.giftMin && cfg.giftVariant && amount >= cfg.giftMin) {
      txt = 'Bravo ! Livraison offerte + ' + gift + ' offert.';
    } else if (cfg.free && amount >= cfg.free) {
      txt = cfg.giftMin && cfg.giftVariant
        ? 'Livraison offerte ✓ Plus que ' + dt(cfg.giftMin - amount) + ' pour recevoir ' + gift + ' offert.'
        : 'Livraison offerte ✓';
    } else if (cfg.free) {
      txt = 'Plus que ' + dt(cfg.free - amount) + ' pour la livraison offerte.';
    } else if (cfg.giftMin && cfg.giftVariant) {
      txt = 'Plus que ' + dt(cfg.giftMin - amount) + ' pour recevoir ' + gift + ' offert.';
    }
    return { text: txt, pct: pct };
  }
  function paintOffer(scope, amount) {
    if (!scope) { return; }
    var s = offerState(amount);
    var t = scope.querySelector('[data-cg-progress-text]');
    var f = scope.querySelector('[data-cg-progress-fill]');
    if (t) { t.textContent = s.text || ' '; }
    if (f) { f.style.width = s.pct + '%'; }
  }

  function renderDrawer(cart) {
    window.cgCart = cart;
    document.querySelectorAll('[data-cg-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.dataset.count = cart.item_count;
    });
    if (!drawer) { return; }
    var lines = drawer.querySelector('[data-cg-lines]');
    var empty = drawer.querySelector('[data-cg-empty]');
    var foot = drawer.querySelector('[data-cg-foot]');
    var html = '';
    var inCart = {};
    cart.items.forEach(function (l) {
      inCart[l.variant_id] = true;
      var gift = isGift(l);
      var img = l.image ? l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = l.variant_title && l.variant_title !== 'Default Title' ? '<p class="cg-line__variant">' + esc(l.variant_title) + '</p>' : '';
      var price = gift && l.final_line_price === 0
        ? 'OFFERT<s>' + dt(l.original_line_price) + '</s>'
        : dt(l.final_line_price) + (l.original_line_price > l.final_line_price ? '<s>' + dt(l.original_line_price) + '</s>' : '');
      html += '<div class="cg-line">' +
        '<div class="cg-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</div>' +
        '<div><p class="cg-line__title"><a href="' + esc(l.url) + '">' + esc(l.product_title) + '</a></p>' + variant +
        (gift ? '<span class="cg-line__gift">CADEAU</span>' :
          '<div class="cg-line__qty"><button type="button" data-cg-qty="' + esc(l.key) + '" data-q="' + (l.quantity - 1) + '" aria-label="Diminuer">−</button>' +
          '<span aria-label="Quantité">' + l.quantity + '</span>' +
          '<button type="button" data-cg-qty="' + esc(l.key) + '" data-q="' + (l.quantity + 1) + '" aria-label="Augmenter">+</button></div>') +
        '</div>' +
        '<div class="cg-line__price">' + price + (gift ? '' : '<button type="button" class="cg-line__remove" data-cg-qty="' + esc(l.key) + '" data-q="0">Retirer</button>') + '</div>' +
        '</div>';
    });
    lines.innerHTML = html;
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    var total = drawer.querySelector('[data-cg-total]');
    if (total) { total.textContent = dt(cart.total_price); }
    drawer.querySelectorAll('[data-cg-upsell-item]').forEach(function (it) {
      it.hidden = !!inCart[parseInt(it.dataset.cgUpsellItem, 10)];
    });
    paintOffer(drawer.querySelector('.cg-drawer__offer'), paidTotal(cart));
    document.dispatchEvent(new CustomEvent('cg:cart', { detail: cart }));
  }

  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cg-lock');
    var c = drawer.querySelector('.cg-drawer__close');
    if (c) { setTimeout(function () { c.focus(); }, 50); }
  }
  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cg-lock');
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function refresh() { return getCart().then(syncGift).then(function (c) { renderDrawer(c); return c; }); }

  function addItems(items, opts, btn) {
    if (busy) { return Promise.resolve(); }
    busy = true;
    if (btn) { btn.classList.add('is-loading'); }
    return api('cart/add.js', { items: items })
      .then(getCart).then(syncGift)
      .then(function (cart) {
        if (opts && opts.checkout) { window.location.href = root + 'checkout'; return cart; }
        renderDrawer(cart);
        if (!(opts && opts.stay)) { openDrawer(); }
        return cart;
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Impossible d’ajouter ce produit.';
        if (opts && opts.onError) { opts.onError(msg); } else { window.alert(msg); }
      })
      .then(function (c) { busy = false; if (btn) { btn.classList.remove('is-loading'); } return c; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cg-cart-open]');
    if (open) { e.preventDefault(); refresh(); openDrawer(); return; }
    if (t.closest('[data-cg-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var add = t.closest('[data-cg-add]');
    if (add) {
      e.preventDefault();
      addItems([{ id: parseInt(add.dataset.cgAdd, 10), quantity: 1 }], { stay: add.hasAttribute('data-cg-stay') }, add);
      return;
    }
    var q = t.closest('[data-cg-qty]');
    if (q) {
      e.preventDefault();
      api('cart/change.js', { id: q.dataset.cgQty, quantity: Math.max(0, parseInt(q.dataset.q, 10)) })
        .then(syncGift).then(renderDrawer).catch(function () { refresh(); });
      return;
    }
    var menu = t.closest('[data-cg-menu]');
    if (menu) {
      var nav = document.getElementById('cg-nav');
      var openNow = nav.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      menu.setAttribute('aria-label', openNow ? 'Fermer le menu' : 'Ouvrir le menu');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) { closeDrawer(); }
  });

  document.querySelectorAll('[data-cg-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- Page produit ---------- */
  document.querySelectorAll('[data-cg-product]').forEach(function (form) {
    var idInput = form.querySelector('[data-cg-variant-id]');
    var qtyInput = form.querySelector('[data-cg-qty-input]');
    var buyBtn = form.querySelector('[data-cg-buy]');
    var addBtn = form.querySelector('[data-cg-addcart]');
    var errEl = form.querySelector('[data-cg-error]');
    var nowEl = form.querySelector('[data-cg-price-now]');
    var wasEl = form.querySelector('[data-cg-price-was]');
    var saveEl = form.querySelector('[data-cg-save]');
    var liveEl = form.querySelector('[data-cg-live-total]');
    var pdpOffer = form.querySelector('[data-cg-pdp-offer]');
    var sticky = document.querySelector('[data-cg-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-cg-sticky-price]') : null;
    var state = { price: parseInt(form.dataset.price, 10) || 0, available: form.dataset.available === 'true' };

    function qty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1); }
    function tier() { return form.querySelector('[name="cg-tier"]:checked'); }
    function addons() {
      var a = [];
      form.querySelectorAll('[data-cg-addon]:checked').forEach(function (c) {
        a.push({ id: parseInt(c.value, 10), quantity: 1, price: parseInt(c.dataset.price, 10) || 0 });
      });
      return a;
    }
    function selection() {
      var t = tier();
      var unit = state.price;
      if (t && t.dataset.mode !== 'single') { unit = parseInt(t.dataset.price, 10) || 0; }
      var s = unit * qty();
      addons().forEach(function (a) { s += a.price; });
      return s;
    }
    function paint() {
      var sel = selection();
      if (liveEl) { liveEl.textContent = dt(sel); }
      if (stickyPrice) { stickyPrice.textContent = dt(sel); }
      var inCart = window.cgCart ? paidTotal(window.cgCart) : 0;
      paintOffer(pdpOffer, inCart + sel);
      [buyBtn, addBtn].forEach(function (b) { if (b) { b.disabled = !state.available; } });
      if (buyBtn && !state.available) { buyBtn.textContent = 'Épuisé'; }
    }

    form.querySelectorAll('[data-cg-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) { return; }
        idInput.value = r.value;
        state.price = parseInt(r.dataset.price, 10) || 0;
        state.available = r.dataset.available === 'true';
        var cmp = parseInt(r.dataset.compare, 10) || 0;
        if (nowEl) { nowEl.textContent = dt(state.price); }
        if (wasEl) { wasEl.textContent = cmp > state.price ? dt(cmp) : ''; wasEl.hidden = !(cmp > state.price); }
        if (saveEl) { saveEl.textContent = cmp > state.price ? 'Économise ' + dt(cmp - state.price) : ''; saveEl.hidden = !(cmp > state.price); }
        if (r.dataset.image) {
          var main = document.querySelector('.cg-gallery__main img');
          if (main) { main.src = r.dataset.image; main.removeAttribute('srcset'); }
        }
        if (buyBtn && state.available) { buyBtn.innerHTML = buyBtn.dataset.label + ' · <span data-cg-live-total></span>'; liveEl = buyBtn.querySelector('[data-cg-live-total]'); }
        var u = new URL(window.location.href); u.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', u.toString());
        paint();
      });
    });
    form.addEventListener('change', function (e) { if (e.target.matches('[data-cg-addon], [data-cg-qty-input], [name="cg-tier"]')) { paint(); } });
    form.querySelectorAll('[data-cg-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + parseInt(b.dataset.cgStep, 10));
        paint();
      });
    });

    function submit(checkout, btn) {
      if (errEl) { errEl.hidden = true; }
      var q = qty();
      var main = parseInt(idInput.value, 10);
      var t = tier();
      var mode = t ? t.dataset.mode : 'single';
      var items = [];
      if (mode === 'qty') {
        items.push({ id: main, quantity: (parseInt(t.dataset.qty, 10) || 1) * q });
      } else if (mode === 'add') {
        items.push({ id: main, quantity: q });
        items.push({ id: parseInt(t.dataset.variant, 10), quantity: q });
      } else if (mode === 'swap') {
        items.push({ id: parseInt(t.dataset.variant, 10), quantity: q });
      } else {
        items.push({ id: main, quantity: q });
      }
      addons().forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
      addItems(items, {
        checkout: checkout,
        onError: function (m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } }
      }, btn);
    }
    if (buyBtn) { buyBtn.addEventListener('click', function (e) { e.preventDefault(); submit(true, buyBtn); }); }
    if (addBtn) { addBtn.addEventListener('click', function (e) { e.preventDefault(); submit(false, addBtn); }); }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(true, buyBtn); });

    if (sticky && buyBtn && 'IntersectionObserver' in window) {
      var sb = sticky.querySelector('button');
      if (sb) { sb.addEventListener('click', function () { submit(true, sb); }); }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      }).observe(buyBtn);
    }

    document.addEventListener('cg:cart', paint);
    paint();
  });

  document.querySelectorAll('[data-cg-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      var main = document.querySelector('.cg-gallery__main img');
      if (!main) { return; }
      main.src = th.dataset.cgThumb;
      main.removeAttribute('srcset');
      document.querySelectorAll('[data-cg-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === th ? 'true' : 'false'); });
    });
  });

  getCart().then(syncGift).then(renderDrawer).catch(function () {});
})();
